<template>
  <component
    :is="icon"
    :fill-color="fillColor"
    :hover-fill-color="hoverColor"
    :size="size"
  />
</template>

<script>
'use strict'

import icons from '../icons/index.js'

export default {
  name: 'BSCIcon',
  components: icons,
  props: {
    icon: {
      type: String,
      required: true
    },
    fillColor: {
      type: String,
      default: '#757575'
    },
    hoverFillColor: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 16
    }
  },
  computed: {
    hoverColor() {
      return this.hoverFillColor === '' ? this.fillColor : this.hoverFillColor
    }
  }
}
</script>

<style></style>
